import commutingCertifiedIcon from '../assets/images/badges/commuting-certified-icon.svg';
import dailyTraceLabelIcon from '../assets/images/badges/daily-trace-icon.svg';
import leisureTraceLabelIcon from '../assets/images/badges/leisure-trace-icon.svg';
import otherTraceLabelIcon from '../assets/images/badges/other-trace-icon.svg';
import potentiallyHomeWorkIcon from '../assets/images/badges/potentially-home-work-icon.svg';
import proTraceLabelIcon from '../assets/images/badges/pro-trace-icon.svg';
import undefinedTraceLabelIcon from '../assets/images/badges/undefined-trace-label-icon.svg';
import { StatsTypes } from './stats';
export const importedSourcesMap = {
  importedGarmin: {
    label: 'Garmin'
  },
  importedWahoo: {
    label: 'Wahoo'
  },
  importedStrava: {
    label: 'Strava'
  }
};
export const traceLabels = ['pro', 'leisure', 'daily', 'other'];
export const traceLabelBadgesMap = {
  pro: {
    bgColor: '#f3edea',
    color: '#846858',
    icon: proTraceLabelIcon
  },
  leisure: {
    bgColor: '#fff5d0',
    color: '#bb8a1a',
    icon: leisureTraceLabelIcon
  },
  daily: {
    bgColor: '#e4f2de',
    color: '#268b1d',
    icon: dailyTraceLabelIcon
  },
  other: {
    bgColor: '#e7f4fa',
    color: '#1589bb',
    icon: otherTraceLabelIcon
  }
};
export const commutingCertifiedBadge = {
  bgColor: '#ecfbf4',
  color: '#048760',
  icon: commutingCertifiedIcon
};
export const potentiallyHomeWorkBadge = {
  color: '#326ac2',
  icon: potentiallyHomeWorkIcon
};
export const undefinedTraceLabelBadge = {
  bgColor: '#f6f8fc',
  borderColor: '#b9bdc3',
  color: '#95999e',
  icon: undefinedTraceLabelIcon
};
export class Trace {
  constructor(id, title, startDate, endDate, geometry, distance, duration, verticalGain, averageSpeed, speeds, elevations, computed, squaredPreviewUrl, previewUrl, hasProblems, problems, source, deviceModelName, commutingStatus, challengesIds, status, referenceTripOccurrences, badges, isPotentiallyBike, bicycleId, stravaActivity, label) {
    this.id = id;
    this.title = title;
    this.startDate = startDate;
    this.endDate = endDate;
    this.geometry = geometry;
    this.distance = distance;
    this.duration = duration;
    this.verticalGain = verticalGain;
    this.averageSpeed = averageSpeed;
    this.speeds = speeds;
    this.elevations = elevations;
    this.computed = computed;
    this.squaredPreviewUrl = squaredPreviewUrl;
    this.previewUrl = previewUrl;
    this.hasProblems = hasProblems;
    this.problems = problems;
    this.source = source;
    this.deviceModelName = deviceModelName;
    this.commutingStatus = commutingStatus;
    this.challengesIds = challengesIds;
    this.status = status;
    this.referenceTripOccurrences = referenceTripOccurrences;
    this.badges = badges;
    this.isPotentiallyBike = isPotentiallyBike;
    this.bicycleId = bicycleId;
    this.stravaActivity = stravaActivity;
    this.label = label;
  }
  get asStats() {
    return {
      [StatsTypes.Distance]: this.distance,
      [StatsTypes.Duration]: this.duration,
      [StatsTypes.VerticalGain]: this.verticalGain,
      [StatsTypes.AverageSpeed]: this.averageSpeed
    };
  }
  clone() {
    return new Trace(this.id, this.title, this.startDate, this.endDate, this.geometry, this.distance, this.duration, this.verticalGain, this.averageSpeed, this.speeds, this.elevations, this.computed, this.squaredPreviewUrl, this.previewUrl, this.hasProblems, this.problems, this.source, this.deviceModelName, this.commutingStatus, this.challengesIds, this.status, this.referenceTripOccurrences, this.badges, this.isPotentiallyBike, this.bicycleId, this.stravaActivity, this.label);
  }
}
export class TraceProblem {
  constructor(problemType, fixDatetime) {
    this.problemType = problemType;
    this.fixDatetime = fixDatetime;
  }
}
export const traceGroundTruths = ['BICYCLE', 'CAR', 'PEDESTRIAN', 'TRAIN', 'PUBLIC_TRANSPORT'];